import { render, staticRenderFns } from "./score-reason-chip.vue?vue&type=template&id=2431def1&"
import script from "./score-reason-chip.vue?vue&type=script&lang=js&"
export * from "./score-reason-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports